import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SaveToBoard } from "@faire/retailer-visitor-shared/features/RetailerBoards/Components/SaveToBoard";
import { SaveToBoardProvider } from "@faire/retailer-visitor-shared/features/RetailerBoards/Context";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getBestProductImage } from "@faire/retailer-visitor-shared/lib/product";
import { getSettingMultiUserGTMV2NoConstraints } from "@faire/retailer-visitor-shared/settings/getSettingMultiUserGTMV2";
import { PageName } from "@faire/retailer-visitor-shared/views/multi-user/Share/consts";
import { ShareButton } from "@faire/retailer-visitor-shared/views/multi-user/Share/ShareButton";
import { getProductHeaderName } from "@faire/retailer-visitor-shared/views/product/__internal__/SEOMetaText";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { ShareableItemType } from "@faire/web-api--source/indigofair/retailer/ShareableItemType";
import React from "react";
import styled from "styled-components";
export var ProductName = function(param) {
    var brand = param.brand, isQuickAddModal = param.isQuickAddModal, centerTitle = param.centerTitle, product = param.product;
    var _product_images;
    useTraceComponentRender("ProductName");
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isFaireDirectActiveInLoggedOut = useFaireDirectBrand().isFaireDirectActiveInLoggedOut;
    var productHeaderName = getProductHeaderName({
        productName: product.name,
        isFaireDirectActiveInLoggedOut: isFaireDirectActiveInLoggedOut
    }, strictLocalize);
    return /*#__PURE__*/ _jsxs(Row, {
        style: {
            width: "100%"
        },
        justify: centerTitle ? "center" : undefined,
        children: [
            /*#__PURE__*/ _jsx(Column, {
                children: /*#__PURE__*/ _jsx(ProductNameAndPrice, {
                    $isQuickAddModal: isQuickAddModal,
                    $centerTitle: centerTitle,
                    "data-test-id": "product-name",
                    children: productHeaderName
                })
            }),
            (brand === null || brand === void 0 ? void 0 : brand.token) && isLoggedInRetailer() ? /*#__PURE__*/ _jsxs(Row, {
                align: "baseline",
                style: {
                    marginLeft: "auto"
                },
                children: [
                    /*#__PURE__*/ _jsx(SaveToBoardProvider, {
                        value: {
                            trackOrigin: "pdp"
                        },
                        children: /*#__PURE__*/ _jsx(SaveToBoard, {
                            iconLightVersion: true,
                            iconSize: "22px",
                            productToken: product.token,
                            productImage: getBestProductImage(product),
                            boardTokens: product.board_tokens,
                            brandToken: brand.token
                        })
                    }),
                    !isQuickAddModal ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "1x"
                            }),
                            /*#__PURE__*/ _jsx(ShareButton, {
                                type: ShareableItemType.PRODUCT,
                                image: (_product_images = product.images) === null || _product_images === void 0 ? void 0 : _product_images[0],
                                name: product.name,
                                subText: brand.name,
                                token: product.token,
                                variant: "tertiary",
                                pageName: getSettingMultiUserGTMV2NoConstraints() ? PageName.GTM_PDP : PageName.PDP
                            })
                        ]
                    }) : null
                ]
            }) : null
        ]
    });
};
// For SEO purpose, we have to make this h1 tag, please don't change unless
// consulted with the SEO team
var ProductNameAndPrice = styled.h1.withConfig({
    componentId: "sc-6f5b0215-0"
})([
    "",
    ";position:relative;word-break:break-word;text-align:",
    ";padding-right:",
    ";"
], function(props) {
    return TypographyStyles({
        variant: "pageHeaderSerifRegular",
        color: "black",
        theme: props.theme
    });
}, function(props) {
    return props.$centerTitle ? "center" : "left";
}, function(props) {
    return props.$isQuickAddModal ? "0" : "30px";
});
